
import { defineComponent, PropType } from 'vue'

// // @components
import PlanningCourierFullness from '@/modules/NewDispatcher/components/PlanningCourierFullness/index.vue'

// @types
import { PlanningCourier } from '@/new-services/types/planning'

export default defineComponent({
    // name: 'courier-card',
    components: {
        PlanningCourierFullness,
    },
    props: {
        courier: {
            type: Object as PropType<PlanningCourier>,
            required: true,
        },
    },
})
